import React, { useState } from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DPage } from '../../../dum';
import { OrderAdjustmentPage } from './order-adjustment/order-adjustment-page';
import { OrderAdjustmentsPage } from './order-adjustments/order-adjustments-page';
import { DFab } from '../../../dum/simple/button/d-fab';
import { SUpsertOrderAdjustmentDialog } from '../../../smart';

const productsPages: Route[] = [
    {
        name: 'OrderAdjustmentsPage',
        path: '/',
        component: <OrderAdjustmentsPage />,
        title: 'Ordenes de ajuste',
        navbar: false,
    },
    {
        name: 'OrderAdjustmentPage',
        path: '/:orderAdjustmentId',
        component: <OrderAdjustmentPage />,
        title: 'Order de ajuste',
        navbar: false,
    },
];

export function OrderAdjustmentsHomePage() {
    const [open, setOpen] = useState(false);

    return (
        <DPage>
            <DFab
                onClick={() => {
                    setOpen(true);
                }}
            />
            <ReactRouterRoutes>
                {productsPages.map((page, index) => {
                    return (
                        <ReactRouterRoute
                            path={page.path}
                            element={page.component}
                            key={index}
                        />
                    );
                })}
            </ReactRouterRoutes>
            <SUpsertOrderAdjustmentDialog open={open} setOpen={setOpen} />
        </DPage>
    );
}
